import { render } from "./Hamburgher.vue?vue&type=template&id=90098458&scoped=true&bindings={\"active\":\"props\"}"
import script from "./Hamburgher.vue?vue&type=script&lang=js"
export * from "./Hamburgher.vue?vue&type=script&lang=js"

import "./Hamburgher.vue?vue&type=style&index=0&id=90098458&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-90098458"

export default script